import styled from 'styled-components'
import { noTouch } from '@/assets/styles/mixins.css'

const Checkbox = styled.div`
  position: relative;
  display: inline-block;
`

Checkbox.Input = styled.input`
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  border: 0;
  padding: 0;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  overflow: hidden;
  pointer-events: none;
  white-space: nowrap;

  &:checked + * {
    --checkbox-inner-opacity: 1;
    --checkbox-inner-transform: scale(1);
  }
`

Checkbox.Label = styled.label`
  display: inline-block;
  padding: 10px 24px 13px 28px;
  font-size: 14px;
  color: var(--color-secondary);
  cursor: pointer;
  transition: color 0.3s ease-out;

  a {
    color: var(--color-decor);
    text-decoration: underline;
    transition: color 0.3s ease-out;

    ${noTouch()`
      &:hover {
        color: var(--color-decor-hover);
      }
    `}
  }

  &::before {
    content: '';
    position: absolute;
    top: 9px;
    left: 0;
    display: block;
    width: 20px;
    height: 20px;
    background: #fff;
    border: 1px solid var(--checkbox-outer-color, var(--color-border));
    border-radius: 1px;
    transition: border-color 0.3s linear;
  }

  &::after {
    content: '';
    position: absolute;
    top: 15px;
    left: 4px;
    display: block;
    width: 12px;
    height: 9px;
    opacity: var(--checkbox-inner-opacity, 0);
    transform: var(--checkbox-inner-transform, scale(0));
    transition: opacity 0.25s, transform 0.25s ease-out;
    background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iOSIgdmlld0JveD0iMCAwIDEyIDkiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+DQo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTExLjgwNDcgMC4xOTUyNjJDMTIuMDY1MSAwLjQ1NTYxMiAxMi4wNjUxIDAuODc3NzIyIDExLjgwNDcgMS4xMzgwN0w0Ljc1NjQ4IDguMTg2MzNDNC40NjE0MiA4LjQ4MTM5IDMuOTgzMDMgOC40ODEzOSAzLjY4Nzk2IDguMTg2MzNMMC4xOTUyNjIgNC42OTM2M0MtMC4wNjUwODc0IDQuNDMzMjggLTAuMDY1MDg3NCA0LjAxMTE3IDAuMTk1MjYyIDMuNzUwODJDMC40NTU2MTIgMy40OTA0NyAwLjg3NzcyMiAzLjQ5MDQ3IDEuMTM4MDcgMy43NTA4Mkw0LjIyMjIyIDYuODM0OTdMMTAuODYxOSAwLjE5NTI2MkMxMS4xMjIzIC0wLjA2NTA4NzQgMTEuNTQ0NCAtMC4wNjUwODc0IDExLjgwNDcgMC4xOTUyNjJaIiBmaWxsPSIjMUM1MENBIi8+DQo8L3N2Zz4NCg==');
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='9' viewBox='0 0 12 9' fill='none'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M11.8047 0.195262C12.0651 0.455612 12.0651 0.877722 11.8047 1.13807L4.75648 8.18633C4.46142 8.48139 3.98303 8.48139 3.68796 8.18633L0.195262 4.69363C-0.0650874 4.43328 -0.0650874 4.01117 0.195262 3.75082C0.455612 3.49047 0.877722 3.49047 1.13807 3.75082L4.22222 6.83497L10.8619 0.195262C11.1223 -0.0650874 11.5444 -0.0650874 11.8047 0.195262Z' fill='%23b69b64'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
  }

  ${noTouch()`
    &:hover {
      color: var(--color-secondary);
      --checkbox-outer-color: var(--color-extra);
    }
  `}
`

export default Checkbox
